/* eslint-disable no-nested-ternary */
import request from '../../utils/request';

export default async (requestRecordId, search) => {
  let params;
  let response;
  if (requestRecordId) {
    params = { requestRecordId };
    response = await request('/receptacles', { params });
  } else if (search) {
    const searchParams = new URLSearchParams(search);
    const reportingStartDate = searchParams.get('reportingStartDate');
    const reportingStopDate = searchParams.get('reportingStopDate');
    const mailClass = searchParams.get('mailClass');
    params = {
      reportingStartDate, reportingStopDate, mailClass,
    };
    if (searchParams.has('operator')) {
      params = { ...params, operator: searchParams.get('operator') };
    }
    if (searchParams.has('carrier')) {
      params = { ...params, carrier: searchParams.get('carrier') };
    }
    if (searchParams.has('impc')) {
      params = { ...params, impc: searchParams.get('impc') };
    }
    response = await request('/receptacles/search', { params });
  } else {
    response = await request('/receptacles');
  }

  return response && response.length ? response.map((receptacle) => {
    const agreementAlaLevel = !receptacle.agreementAlaLevel ? null
      : receptacle.agreementAlaLevel === -1 ? 'Fail'
        : receptacle.agreementAlaLevel;
    const alaLevel = receptacle.agreementAlaLevel ? null
      : receptacle.alaLevel === -1 ? 'Fail'
        : receptacle.alaLevel;
    const { despatchIdentifier = '' } = receptacle;
    const despatchIdentifierShort = despatchIdentifier ? despatchIdentifier.slice(-4) : '';
    const weight = (Math.round((receptacle.weight / 10) * 100) / 100).toFixed(1);

    return {
      ...receptacle,
      despatchIdentifierShort,
      agreementAlaLevel,
      alaLevel,
      weight,
    };
  }) : response;
};
